import { TdsFooter as Footer, TdsFooterProps } from '@tencent/tds-ui-lite';
import React, { FC } from 'react';

export const TdsFooter: FC<TdsFooterProps> = props => (
  <Footer {...props} />
);
